const Roles = {
  ROLE_READ_TEAM: "ROLE_READ_TEAM",
  ROLE_WRITE_TEAM: "ROLE_WRITE_TEAM",
  ROLE_READ_NOTIFICATION: "ROLE_READ_NOTIFICATION",
  ROLE_SEND_NOTIFICATION: "ROLE_SEND_NOTIFICATION"
};

export default Roles;